import React from 'react';
import { Loader } from './styles';
import './style.css';


const Assinatura: React.FC = () => {
    return (
        <Loader src="https://homolog.agevap.gt4w.com.br/assinatura/#/home" frameborder="0" title='Sistema legado'></Loader>
    );
};

export default Assinatura;